export default __webpack_public_path__ + "static/media/surprised-cat.f44fdf25.svg";